<template>
  <section class="a-research _no-multi">
    <div class="a-research__title-wrap a-market__title">
      <h2
        v-if="researchData.title"
        class="a-research__title"
      >
        {{ researchData.title }}
      </h2>
      <div class="a-research__links-wrap">
        <div class="a-research__select">
          <select-date-filter
            @option-selected="optionSelected"
            @date-selected="dateSelected"
          />
        </div>
        <a
          v-if="researchData.link"
          class="a-research__link"
          :href="researchData.link.href"
          :title="researchData.link.title"
        >
          {{ researchData.link.title }}
        </a>
      </div>
    </div>
    <div
      class="a-research__container"
      :class="[
        { full: researchData.full },
        { '_opened': showMore },
        researchData.addClass
      ]"
      ref="resizeContainer"
    >
      <template v-if="researchDataItems.data && researchDataItems.data.length !== 0">
        <div class="a-research__items">
          <template
              v-for="item in researchDataItems.data.slice(0, howMuchSlice)"
              :key="`res-${item.id}`"
          >
            <research-one-item
                :use-description="!researchData.disableDescription"
                :report-file="item.props.file"
                :press-release-href="item.props.href_press_release"
                :name="item.name"
                :period="item.props.period"
                :preview-text="item.preview_text"
                :link-to-report="item.props.link_to_report"
                addClasses="_no-multi"
            />
          </template>
        </div>
        <div
          :class="{ '_show': showMore }"
          class="a-research__items _more"
          v-if="researchDataItems.data.length > 3"
        >
          <template
            v-for="item in researchDataItems.data.slice(howMuchSlice)"
            :key="`res-${item.id}`"
          >
            <research-one-item
              :use-description="!researchData.disableDescription"
              :report-file="item.props.file"
              :press-release-href="item.props.href_press_release"
              :name="item.name"
              :period="item.props.period"
              :preview-text="item.preview_text"
              addClasses="_no-multi"
            />
          </template>
        </div>
      </template>
      <empty-text
        v-else
        :empty-text="emptyText"
      />
    </div>
    <show-more-btn
      v-if="
        researchDataItems.data &&
        researchDataItems.data.length > 3
      "
      :full-list="researchData.full"
      :desktop-small-device="true"
      :show-more="showMore"
      :has-mobile-device="mobileDevice"
      @toggleHeight="toggleHeight"
    />
  </section>
</template>

<script>
import ResearchOneItem from './ResearchOneItem'
import ShowMoreBtn from './helpers/ShowMoreBtn'
import SelectDateFilter from './helpers/SelectDateFilter'
import EmptyText from './helpers/EmptyText'

export default {
  name: 'Research',
  props: {
    desktopSmallDevice: Boolean,
    desktopDevice: Boolean,
    tabletDevice: Boolean,
    mobileDevice: Boolean,
    researchData: Object,
    researchDataItems: Object
  },
  data() {
    return {
      showMore: false,
      resizeHeight: '',
      pageCounter: 1,
      perPage: 6,
      emptyText: 'За данный период ничего не найдено.'
    }
  },
  components: {
    ResearchOneItem,
    ShowMoreBtn,
    SelectDateFilter,
    EmptyText
  },
  computed: {
    howMuchSlice () {
      if (this.tabletDevice) {
        return this.researchData.disableDescription ? 4 : 2;
      }
      if (this.mobileDevice) {
        return 3;
      }
      return this.researchData.disableDescription ? 6 : 3;
    }
  },
  methods: {
    toggleHeight() {
      if (this.showMore) {
        this.showMore = false
        this.$emit('onhide')
      } else {
        this.$nextTick(() => {
          this.showMore = true
        });
      }
    },

    optionSelected(id) {
      this.pageCounter = 1
      this.$emit('optionSelected', id)
      this.$refs.resizeContainer.style.height = `${this.resizeHeight}px`;
      this.showMore = false
    },

    dateSelected(dateStart, dateEnd) {
      this.pageCounter = 1
      this.$emit('dateSelected', dateStart, dateEnd)
      this.$refs.resizeContainer.style.height = `${this.resizeHeight}px`;
      this.showMore = false
    }
  }
}
</script>